<template>
    <div class="article-content">
        <el-scrollbar class="article-wrap">
            <div class="top-tab">
                <div class="btn-box">
                    <el-button type="primary" @click="goBack">返回</el-button>
                </div>
            </div>
            <div class="main-content">
                <div class="main-wrap">
                    <!-- <div class="top-title">
                        {{articleInfo.title}}
                    </div> -->
                    <!-- <div class="top-description">
                          <span>上传视频：</span>
                        {{articleInfo.description}}
                    </div> -->
                  
                    <div class="top-people" style="display: flex">
                          <span>上传视频：</span>
                            <div style="display: flex;flex-wrap: wrap;width: 90%;">
                                <div class="top-video" v-for="(item, index) in articleInfo.video" :key="index" style="width: 200px;height: 200px;margin-bottom: 20px;background-color: #000;margin-right: 10px;">
                                <video style="width: 200px;height: 100%;"  :src="item.url" controls="controls" autoplay>
                                    您的浏览器不支持 video 标签。
                                </video>
                            </div>
                       
                    </div>
                     
                    </div>
                     <div class="top-people">
                         <span>标题：</span>
                        {{this.title}}
                    </div>
                      <div class="top-people">
                         <span>描述：</span>
                        {{this.description}}
                    </div>
                     <div class="top-people">
                         <span>目标人群：</span>
                        {{this.people}}
                    </div>
                   
                </div>
            </div>
        </el-scrollbar>
    </div>
</template>

<script>
    import {stuOpArticleDetail} from '@/utils/apis'

    export default {
        name: "articleDetail",
        data() {
            return {
                articleId: Number(this.$route.query.article_id) || null,
                articleInfo: {},
                crowdList:['手机','美搭','型男','数码','美容','母婴','旅行','居家'],
                title:'',
                description:'',
                people:''
            }
        },
        created() {
            if (this.articleId !== null) {
                this.getEditList();
            }
        },
        methods: {
            getEditList() {
                let param = {
                    id: this.articleId
                }
                stuOpArticleDetail(param).then(res => {
                    this.articleInfo = res.data;
                    this.articleInfo.video = JSON.parse(res.data.video);
                    this.title = res.data.title
                    this.description = res.data.description
                    this.people = this.crowdList[this.articleInfo.people]
                    this.articleInfo.people = this.crowdList[this.articleInfo.people];

                    console.log(res,'5555');
                }).catch(err => {
                    console.error(err)
                })
            },
            goBack() {
                this.$router.go(-1)
            },
        }
    }
</script>

<style scoped lang="scss">
    .article-content {
        position: fixed;
        top: 60px;
        bottom: 0;
        width: calc(100% - 230px);
        margin-top: 100px;
        background: #F5F7F6;
        

        .article-wrap {
            height: 100%;
            display: flex;
            flex-direction: column;

            ::v-deep > .el-scrollbar__wrap {
                overflow-x: hidden;

                .el-scrollbar__view {
                    display: flex;
                    flex-direction: column;
                    height: 100%;
                    margin: 20px;
                    background: #ffffff;
                }
            }
        }
        .top-people{
            padding: 20px 0;
        }
        .top-tab {
            display: flex;
            justify-content: flex-end;
            border-bottom: 1px solid #F1F5FF;
            height: 40px;
            padding: 10px 0;

            .el-button {
                margin-right: 20px;
            }
        }

        .main-content {
            margin-top: 20px;
            flex: 1;
            background: #fff;
            .main-wrap {
                width: 900px;
                margin: 0 auto;
                box-shadow: 0px 0px 10px #dcdfe6;
                padding: 30px 30px;
                margin-bottom: 15px;
                .top-title {
                    text-align: center;
                    font-size: 20px;
                    color: #333333;
                }

                .top-author {
                    margin-top: 12px;
                    text-align: center;
                    font-size: 14px;
                    color: #666666;
                }

                .top-content {
                    margin-top: 20px;

                    ::v-deep p {
                        img {
                            max-width: 900px;
                        }
                    }
                }
            }
        }
    }
</style>